import { WizardNavItemProps } from '@valid-eval/shared-react-components/dist/components/Wizard/WizardNavIitem';
import { Event } from 'data/features/eventsTypes';

import ArtifactsStepComponent from './ArtifactsStep';
import DocumentsStepComponent from './DocumentsStep';
import EventStepComponent from './EventStep';
import JudgesStepComponent from './JudgesStep';
import PhasesStepComponent from './PhasesStep';
import TeamsStepComponent from './TeamsStep';
import UsersStepComponent from './UsersStep';

export type Step = {
  eventKey: string;
  id: string;
  label: string;
  subLabel: string;
  variant: WizardNavItemProps['variant'];
  disabled?: boolean;
  navigation?: boolean;
  needDraft?: boolean;
  component: React.ComponentType<EventStepComponentProps>;
  nextStep?: () => void;
};

export type EventStepComponentProps = {
  event: Event;
  label: string;
  subLabel: string;
  documents?: any[];
  step: Omit<Step, 'component'>;
  nextStep: () => void;
};

export const EventStep: Step = {
  eventKey: 'event',
  id: 'event',
  label: 'event.form.title',
  subLabel: 'event.form.progress',
  variant: 'default',
  disabled: false,
  navigation: true,
  component: EventStepComponent,
};

export const OrganizersStep: Step = {
  eventKey: 'organizers',
  id: 'organizers',
  label: 'event.form.organizers_title',
  subLabel: 'event.form.progress',
  variant: 'default',
  disabled: false,
  navigation: true,
  component: UsersStepComponent,
};

export const NavigatorsStep: Step = {
  eventKey: 'navigators',
  id: 'navigators',
  label: 'event.form.navigators_title',
  subLabel: 'event.form.progress',
  variant: 'default',
  disabled: false,
  navigation: true,
  component: UsersStepComponent,
};

export const DocumentsStep: Step = {
  eventKey: 'documents',
  id: 'documents',
  label: 'event.form.documents_title',
  subLabel: 'event.form.progress',
  variant: 'default',
  disabled: false,
  navigation: true,
  component: DocumentsStepComponent,
};

export const JudgesStep: Step = {
  eventKey: 'judges',
  id: 'judges',
  label: 'event.form.judges_title',
  subLabel: 'event.form.progress',
  variant: 'default',
  disabled: false,
  navigation: true,
  component: JudgesStepComponent,
};

export const TeamsStep: Step = {
  eventKey: 'teams',
  id: 'teams',
  label: 'event.form.teams_title',
  subLabel: 'event.form.progress',
  variant: 'default',
  disabled: false,
  navigation: true,
  component: TeamsStepComponent,
};

export const ArtifactsStep: Step = {
  eventKey: 'artifacts',
  id: 'artifacts',
  label: 'event.form.artifacts_title',
  subLabel: 'event.form.progress',
  variant: 'default',
  disabled: false,
  navigation: true,
  component: ArtifactsStepComponent,
};

export const PhasesStep: Step = {
  eventKey: 'phases',
  id: 'phases',
  label: 'event.form.phases_title',
  subLabel: 'event.form.progress',
  variant: 'default',
  disabled: false,
  navigation: true,
  component: PhasesStepComponent,
};

export const EditEventSteps: Step[] = [
  EventStep,
  OrganizersStep,
  NavigatorsStep,
  DocumentsStep,
  JudgesStep,
  TeamsStep,
  ArtifactsStep,
  PhasesStep,
];
